import { FETCH_GENERIC_PAGE } from 'state/actions/genericPageActions';

const initialState = {
  genericPage: {}
};

const reducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case `${FETCH_GENERIC_PAGE}_FULFILLED`:
      return {
        ...state,
        genericPage: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
